import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { Text } from 'components/core/Typography';
import { Link } from 'components/core/Link';

import './LinkFarm.scss';

export default function LinkFarm({ links, columns, primary, size }) {
	return (
		<ul className="link-farm">
			{links.map((link) => (
				<li
					key={link.label}
					className={classnames('link-item', `columns-${columns}`)}
				>
					<Text
						size={size}
						weight="standard"
						last
					>
						<Link
							secondary={!primary}
							primary={primary}
							to={link.uri}
						>
							{link.label}
						</Link>
					</Text>
				</li>
			))}
		</ul>
	);
}

LinkFarm.propTypes = {
	columns: PropTypes.number,
	links: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string.isRequired,
			uri: PropTypes.string.isRequired,
		}),
	).isRequired,
	primary: PropTypes.bool,
	size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large', 'mega']),
};

LinkFarm.defaultProps = {
	columns: 4,
};
